import { z } from 'zod';
import { optionalUuidArray } from '../zod-helpers/index.js';
import { arBusinessDateInput } from './ar-business-date-input.js';
import { AR_SEARCH_MAX_LENGTH } from './ar-search-max-length.js';
export const arAgingReportInputSchema = z.object({
    asOfDate: arBusinessDateInput.nullish(),
    brandIds: optionalUuidArray('Invalid brand selection.').nullish(),
    shipToStateIds: optionalUuidArray('Invalid state selection.').nullish(),
    customerIds: optionalUuidArray('Invalid customer selection.').nullish(),
    paymentTermsIds: optionalUuidArray('Invalid payment terms selection.').nullish(),
    pastDueOnly: z.boolean().nullish(),
    search: z.string().trim().max(AR_SEARCH_MAX_LENGTH).nullish(),
});
//# sourceMappingURL=ar-aging-report-input.js.map